import Link from "next/link";
import React from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

export default function NavbarProfile({
  customer,
  logout,
  navbarToggle,
  showNavDd,
}) {
  return (
    <div className="hidden md:flex lg:flex nav-item dropdown relative">
      <button
        className="flex justify-center items-center gap-4 nav-link active px-3 py-5"
        onClick={() => navbarToggle()}
      >
        <p className="text-black">Hello, {customer?.name}!</p>
        {showNavDd ? (
          <IoIosArrowUp className="w-4 h-4 text-black" />
        ) : (
          <IoIosArrowDown className="w-4 h-4 text-black" />
        )}
      </button>
      {showNavDd && (
        <div className="dropdown-menu absolute bg-black text-white  top-full left-0 w-36 h-fit   z-[999]">
          <ul className="flex flex-col justify-between gap-3">
            <li className="text-center hover:bg-blue-400" onClick={() => navbarToggle()}>
              <Link href={"/profile"} className="py-3 flex justify-center items-center">My Profile</Link>
            </li>
          </ul>
          <span className="text-center " onClick={() => navbarToggle()}>
            <button
              onClick={logout}
              className=" w-full hover:bg-blue-400 py-3 cursor-pointer"
            >
              Logout
            </button>
          </span>
        </div>
      )}
    </div>
  );
}
